import { render } from "./EditorColor.vue?vue&type=template&id=0bea76cb"
import script from "./EditorColor.vue?vue&type=script&lang=js"
export * from "./EditorColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__